import { render } from "./dialysis_procedure.vue?vue&type=template&id=c7e1d884&scoped=true"
import script from "./dialysis_procedure.vue?vue&type=script&lang=js"
export * from "./dialysis_procedure.vue?vue&type=script&lang=js"

import "./dialysis_procedure.vue?vue&type=style&index=0&id=c7e1d884&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7e1d884"]])

export default __exports__